export const GOOGLE_STORE_LINK =
  "https://play.google.com/store/apps/details?id=com.sookind.sookind"
export const APPLE_STORE_LINK =
  "https://apps.apple.com/us/app/sookind/id1514935645"
export const FACEBOOK_PAGE_LINK = "https://www.facebook.com/sookindapp"
export const TWITTER_PAGE_LINK = "https://twitter.com/sookindapp"
export const TERMS_AND_CONDITIONS_TEMPLATE_LINK =
  "https://termsandconditionstemplate.com/"
export const PRIVACY_POLICY_TEMPLATE_LINK =
  "https://www.privacypolicytemplate.net/"
export const GOOGLE_PRIVACY_POLICY = "https://policies.google.com/privacy"
export const FIREBASE_PRIVACY_POLICY =
  "https://firebase.google.com/support/privacy"
export const FLATICON_URL = "https://www.flaticon.com/home"
export const FREEPIK_URL = "https://www.freepik.com/"
